const PATH = '/basicdata/icd9'
const childrenOf = (items) =>
  Array.isArray(items) ? items : Object.values(items || {})
const pathOf = (item) =>
  String(item?.url || '')
    .split('?')[0]
    .replace(/\/$/, '')
const contains = (items) =>
  childrenOf(items).some(
    (item) => pathOf(item) === PATH || contains(item?.children)
  )

export const addIcd9Menu = (items = []) => {
  if (!Array.isArray(items) || contains(items)) return items
  let inserted = false
  const visit = (entries) =>
    childrenOf(entries).reduce((result, item) => {
      if (!item) return result
      result.push(
        item.children ? { ...item, children: visit(item.children) } : item
      )
      if (!inserted && pathOf(item) === '/basicdata/operative-item') {
        result.push({
          access: item.access || [],
          groupMenuId: item.groupMenuId,
          icon: 'feather icon-book-open',
          id: `${item.groupMenuId || 'basicdata'}-icd9`,
          linkType: 'router',
          seq: Number(item.seq || 0) + 0.001,
          title: 'ICD9',
          type: 'item',
          url: PATH,
        })
        inserted = true
      }
      return result
    }, [])
  return visit(items)
}
